<template>
  <div class="ListMarketplaceRecebiveis">
    <HeaderPage>
    </HeaderPage>
    <el-card v-loading="loadingPage" style="max-width: 1300px">
      <FilterBoxReceivables v-on:filterExport="exportDados" :currentPage="listData.meta ? listData.meta.pagination.current_page : 1" />
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import {getExportMarketplaceReceivables} from "@/app/domains/Report/services";
import FilterBoxReceivables from "./FilterBoxMarketplaceReceivables.vue";


export default {
  name: "ListMarketplaceRecebiveis",
  components: {
    HeaderPage,
    FilterBoxReceivables
},
  data () {
    return {
      loadingPage: false,
      listData: {}
    }
  },
  methods: {
    async exportDados (arg) {
      this.loadingPage = true
      try {
        let response = await getExportMarketplaceReceivables(arg)
        window.open(response.data, '_blank')
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.body[0].messages[0],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
  },

}
</script>

<style scoped>

</style>
